import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import UpdateBanner from "./components/UpdateBanner";
import "./index.css";
import { initNativeChrome } from "./services/native";

// Status bar + splash handling when running as an installed app; a no-op on web.
initNativeChrome();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* every shell (office, driver app, login) gets the reload prompt after a deploy */}
    <UpdateBanner />
    <App />
  </React.StrictMode>
);

// Register the service worker so drivers can install the app to their home
// screen (and open it in a dead spot). Only in production builds - the CRA
// dev server and a cached shell fight each other.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* installability is a bonus; the app works without it */
    });
  });
}
